import { useContext, useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { JourneyContext } from "../../CONTEXT/JourneyStore";
import currency from "currency.js";
import { Link } from "react-router-dom";
import { Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

// the template for each bike in the bike list
const IndividualBike = (props) => {
  const [gState, setGState] = useContext(JourneyContext);
  const [editMode, SetEditMode] = useState(false);
  const [showEditBikeMessage, setShowEditBikeMessage] = useState(false);
  const [opened, { close, open }] = useDisclosure(false);
  const [isElectric, setIsElectric] = useState(false);
  const [electricAgreed, setElectricAgreed] = useState(false);
  let bike = props.bike;
  function enforceMinMax(el) {
    if (el.value != "") {
      if (parseInt(el.value) < parseInt(el.min)) {
        el.value = el.min;
      }
      if (parseInt(el.value) > parseInt(el.max)) {
        el.value = el.max;
      }
    }
  }

  useEffect(() => {
    if (props.validateNextButton && gState.currentlyEditingABike) {
      setShowEditBikeMessage(true);
    }
  },[props.validateNextButton, gState.currentlyEditingABike]);

  const formik = useFormik({
    initialValues: {
      //usually these are set to null/empty except we want to pre populate the data we wish to edit (passed as a prop)
      id: bike.id,
      bikeMake: bike.make,
      bikeModel: bike.model,
      bikeValue: bike.value,
      isElectric: bike.isElectric,
    },
    validationSchema: Yup.object({
      bikeMake: Yup.string()
        .required("Bike Make is required")
        .min(2, "This bike name is too short")
        .max(20, "This bike make name is too long"),
      bikeModel: Yup.string()
        .required("Bike Model is required")
        .min(2, "This bike model is too short")
        .max(40, "This bike model name is too long"),
      bikeValue: Yup.number()
        .required("Bike Value is required")
        .min(
          500,
          <small className="redFont mt-1 lufga-light">
            Only bikes valued £500 or more can be insured
          </small>
        )
        .max(
          20000 -
          (gState?.bikes?.map((m) => m.value).reduce((a, b) => a + b, 0) -
            bike.value),
          <small className="redFont mt-1 lufga-light">
            Sorry, you've exceeded our £20,000 online quoting limit. Please call
            us on{" "}
            <a
              className="redFont"
              rel="noreferrer"
              href="tel:08000833035"
              target="_blank"
            >
              {" "}
              0800 083 3035
            </a>{" "}
            for a personalised quote
          </small>
        ),
    }),
    onSubmit: (values, { resetForm }) => {
      if (isElectric && !electricAgreed) {
        return open();
      }
      setElectricAgreed(false);
      close();
      setShowEditBikeMessage(false);
      const editedBike = {
        id: bike.id,
        make: values.bikeMake,
        model: values.bikeModel,
        value: values.bikeValue,
        isElectric: values.isElectric,
      };

      const bikes = gState.bikes.map((bike) => {
        if (bike.id == editedBike.id) {
          return editedBike;
        }
        return bike;
      });

      bike = editedBike;

      setGState({
        ...gState,
        bikes: bikes,
        currentlyEditingABike: false,
        currentlyAddingABike: false,
        resetAwayValue: true,
        awayValue: 0,
      });
      SetEditMode(false);
    },
  });

  const handleCancel = (e) => {
    e.preventDefault();
    setShowEditBikeMessage(false);
    setIsElectric(bike.isElectric);
    formik.values.isElectric = bike.isElectric;
    resetForm();
    formik.resetForm();
  };

  const handleRemove = (id) => {
    let filteredArray = gState.bikes.map((a) => {
      // make a copy
      return { ...a };
    });
    // create a new array that doesnt include the bike we want to delete. Set this as the new bike collection.
    const filtered = filteredArray.filter((x) => x.id !== id);
    setGState({
      ...gState,
      bikes: filtered,
      resetAwayValue: true,
      awayValue: 0,
      yourQuoteCrumb: gState.validatedRules != null ? 0 : gState.yourQuoteCrumb
    }); // copy new version to the main object - dont change the state directly
    // resetForm();
  };

  const handleEdit = () => {
    // get the bike from journeyContext using this id above
    const bikeEdited = { ...bike };
    setGState((prevState) => {
      return {
        ...prevState,
        id: bikeEdited.id,
        make: bikeEdited.make,
        model: bikeEdited.model,
        value: bikeEdited.value,
        isElectric: bikeEdited.isElectric,
        currentlyEditingABike: true,
        resetAwayValue: true,
        awayValue: 0,
        generateQuote: true,
      };
    });

    // expand this form and display the fields to edit, hiding the top section
    SetEditMode(true);
  };

  const resetForm = () => {
    setGState((prevState) => {
      return {
        ...prevState,
        id: null,
        make: "",
        model: "",
        value: 0,
        isElectric: false,
        accessoryCover: false,
        worldwideCover: false,
        sportsCover: false,
        personalAccident: false,
        currentlyEditingABike: false,
        currentlyAddingABike: false,
      };
    });
    SetEditMode(false);
  };

  const thisBike = bike;

  const handleIsElectric = (e, flag) => {
    e.preventDefault();
    setIsElectric(flag);
    formik.values.isElectric = flag;
  };
  var center = true;
  var fs = false;

  return (
    <section className="container container_narrow mt-3">
      <Modal opened={opened} onClose={close} className="electricBikeModal" centered withCloseButton={false}>
      <div className="row">
        <p>
          Please confirm the electric cycle maximum motor power does not exceed 250 Watts and the electric assistance cut-off speed does not exceed 15.5mph.
          We do not insure electric cycles that exceed this criteria, as the bike comes under the Road Traffic Act, which means tax and licensing – <a href="https://www.gov.uk/electric-bike-rules" target="_blank" rel="noreferrer">
            see Electric bikes: licensing, tax and insurance
          </a> for further details.

        </p>

          <div className="col-6 mt-3">
            <button
              type="submit"
              id="Add-this-bike"
              onClick={() => { setElectricAgreed(true); formik.submitForm(); }}
              className="btn btn-primary m-1 btn-100 pt-2 pb-2"
            >
              Save Changes
            </button>
          </div>


          <div className="col-6  mt-3">
            <button
              onClick={(e) => { handleCancel(e); close(); }}
              className="btn btn-secondary btn-100 pt-2 pb-2"
            >
              Cancel
            </button>
          </div>

        </div>
      </Modal>
      {editMode === false && (
        <div className="content_section">
          <div className="row mb-1">
            <div className="col-2 col-sm-1">
              {thisBike.isElectric === true ? (
                <svg width="41.476" height="42.31" viewBox="0 0 41.476 42.31">
                  <defs>
                    <clipPath id="clip-path">
                      <rect
                        id="Rectangle_764"
                        data-name="Rectangle 764"
                        width="39.421"
                        height="40.303"
                        fill="#00a800"
                      />
                    </clipPath>
                  </defs>
                  <g
                    id="Group_1840"
                    data-name="Group 1840"
                    transform="translate(41.476 40.247) rotate(177)"
                  >
                    <g
                      id="Group_1684"
                      data-name="Group 1684"
                      transform="translate(0 0)"
                      clipPath="url(#clip-path)"
                    >
                      <path
                        id="Path_2057"
                        data-name="Path 2057"
                        d="M31.4,17.252a8.057,8.057,0,0,1-1.93-.243l-.08.26a.288.288,0,0,1-.464.127l-.211.613a.133.133,0,0,1,.02.19,1.6,1.6,0,0,1-.211.464v.031c.011.086.028.2.048.344l.292.067A3.073,3.073,0,0,1,31.181,20.9l.376-.441c.255-.13-.062.294-.062.294a.582.582,0,0,0-.041.633l.126-.211c.253-.062.314.423.314.423.254,0,.447.57.447.57l-.087-.444c-.062-.4.064-.506.064-.506l.38-.507a1.706,1.706,0,0,1,.316-.231c.19.064-.127.317-.127.317a1.218,1.218,0,0,0-.124.78c.189-.126.233-.041.233-.041.21.169,0,.654,0,.654a1.615,1.615,0,0,0-.087.441l-.21.53a.725.725,0,0,1,.21.569.407.407,0,0,1-.25.443.582.582,0,0,1-.678-.041,2,2,0,0,1-.589.253,4.872,4.872,0,0,0-.783.294.865.865,0,0,1-.4.211c-.4.444-2.324,2.828-2.324,2.828a13.405,13.405,0,0,1-2.067,1.857,13.8,13.8,0,0,0-1.16,1.1l-.63.8c.083.084-.193.484-.193.484l-.148.593a5.14,5.14,0,0,1-.294.864l.1.041a1.222,1.222,0,0,1,.654-.3.378.378,0,0,1,.571.36.577.577,0,0,0,.126.337.264.264,0,0,1,.044.3l.189-.023c.191-.04.233.276.233.276l.23.254.32-.086c.272-.02.126.7.126.7a1.9,1.9,0,0,1,.4.569c.126.338-.19.359-.19.359v.466l.844.274.527-.213c.359-.04.063.3.063.3-.063.063-.484.7-.484.7a7.872,7.872,0,0,1-1.265,1.71,3.828,3.828,0,0,1-2.891.844l-2.237-.338c-.338.021-.211-.253-.211-.253l.148-.317-.211.107c-.148.063-.17-.127-.17-.127l-.02-.3.423-.337a.564.564,0,0,1-.274-.317,1.35,1.35,0,0,1,.4-1.118c-.211-.19-.126-.59-.126-.59-.381.337-.506-.147-.506-.147.062-.34-.17-.36-.17-.36a1.146,1.146,0,0,1-.865-.147l-.95-.421-1.941-.865a19.193,19.193,0,0,1-2.932-1.71A9.178,9.178,0,0,1,11.684,31.6L9.743,29.149c-.887-.634-.55-1.12-.55-1.12l-.5-1.138a2.355,2.355,0,0,1-.15-2.618l.317-.547c-.357-.106.086-.548.086-.548l-.359-1.118A1.462,1.462,0,0,1,8.9,20.666v-.4c.169,0,.147.36.147.36l1.477-.107.466-.231.147-.443a12.474,12.474,0,0,1,.78-2.069l-.1-.421-.273-.211-.36-.843c-.55.106-.718-.527-.718-.527l-.012-.1a8.026,8.026,0,1,1,4.376-11.9l0-.051c.064-.844,1.224-.738,1.224-.738a3.88,3.88,0,0,1,.824.124c.167.15.676.128.676.128a6.692,6.692,0,0,0,1.2-.064c-.486-.231.084-.463.084-.463l1.034.146a.281.281,0,0,1,.253.21l-.148.171c.4.1,1.14.4,1.14.4.59.337.527.654.527.654-.041.464-.676.464-.676.464l-1.181.127c.02.19-.359.253-.359.253a2.587,2.587,0,0,1,.19,3.208l6.88,8.418c.379.421.484.064.484.064l.3-.72A8.012,8.012,0,1,1,31.4,17.252m-1.5-1.121,1.332-5.925a33.158,33.158,0,0,0-2.471,5.57,6.942,6.942,0,0,0,1.138.354m1.8-6.438,2.223,6.123a6.97,6.97,0,0,0,1.7-.943L31.728,9.68a.255.255,0,0,1-.037.013m-.083.028a.512.512,0,0,1-.075.013l.278,6.523a7.012,7.012,0,0,0,2.019-.415Zm-.661-.26h0L24.9,12.01a7.052,7.052,0,0,0,.973,1.579l4.884-3.816.193-.31m-.008-.094a.667.667,0,0,1,.008-.209l-6.595.332a7.04,7.04,0,0,0,.512,2.435ZM31.007,9l-.274-.385-5.1-3.461a7.021,7.021,0,0,0-.922,1.87L31,9.019,31.007,9m.051-.08a.608.608,0,0,1,.051-.051l-.166-.112Zm.119-.111a.855.855,0,0,1,.1-.068L29.028,2.592a7.022,7.022,0,0,0-1.8.95L30.8,8.552Zm.1-.329-.092-6.3a6.966,6.966,0,0,0-2.075.391Zm.708.531c0,.015.011.028.015.043L38.44,8.94a7.007,7.007,0,0,0-.4-2.067Zm6.024-2.223a7,7,0,0,0-1.018-1.841L32.166,8.856ZM32.023,9.143a1.2,1.2,0,0,1,.019.13c-.005.04-.028.06-.039.095l6.148,1.847a6.974,6.974,0,0,0,.318-1.987c0-.07-.019-.132-.02-.2Zm.092.353,5.109,3.73a7.024,7.024,0,0,0,.9-1.925Zm5.053,3.8L31.952,9.487a.488.488,0,0,1-.15.147l3.881,5.182a7.09,7.09,0,0,0,1.485-1.522m-5.447,2.972L31.448,9.85c-.025.04-.051.083-.078.124l-1.389,6.182A7.044,7.044,0,0,0,31.4,16.3c.111,0,.214-.027.324-.032m-3.18,1.72.147-.57-.443-.276-.528,1.33.754.531c-.009-.067-.016-.126-.025-.178l-.054-.2c-.062-.191.148-.633.148-.633m-.887.758-.19.528.761.274.02-.234Zm-.166,1.387a4.669,4.669,0,0,1,1.288,1.833c-.021-.429-.063-.912-.112-1.377a3.085,3.085,0,0,0-1.176-.456m2.162.436a2.775,2.775,0,0,1,.495,1.025c.3-.357.318.444.318.444l.189.041a.9.9,0,0,0,.063-.528,2.626,2.626,0,0,0-1.169-1.4,2.927,2.927,0,0,1,.1.415m-.221-.479a2.333,2.333,0,0,0-.53-.2,2.7,2.7,0,0,1,.627.531,2.99,2.99,0,0,0-.1-.326m0,2.326a1.566,1.566,0,0,0,.033-.318,2.858,2.858,0,0,1-.167.3Zm-.23-.039a2.587,2.587,0,0,0,.255-.482,1.756,1.756,0,0,0-.385-.943c.011.138.021.3.021.467a3.528,3.528,0,0,1-.111.922Zm-.314-.051h.005A3.475,3.475,0,0,0,29,21.419a4.934,4.934,0,0,0-.036-.578,1.6,1.6,0,0,0-.2-.182c.059.574.108,1.168.119,1.656l0,.011M15.608,21.108l.907-.043a.327.327,0,0,1,.421,0s.738.15.845.064a11.714,11.714,0,0,1-1.837-1.815l-.464-.062-.17,1.793a.3.3,0,0,0,.3.063M12.723,4.455,9.055,7.424c.02.043.032.076.048.115l5.533-1.957A7.031,7.031,0,0,0,14.1,4.46c-.375-.005-.855-.007-1.376-.005M14.015,4.3c-.124-.2-.261-.384-.4-.569l-.72.583ZM9.17,4.479,8.82,5.762c.032.04.058.07.058.07a.935.935,0,0,1,.274.3c0,.043-.027.084-.04.127l1.245-1.789c-.487,0-.9.008-1.187.012m1.268-.128,1.53-2.2a7.041,7.041,0,0,0-1.926-.874L9.2,4.366ZM6.156,7.9l.025.041L7.072,7.9A1.076,1.076,0,0,1,7.1,7.756l-1.01-.32a1.448,1.448,0,0,0,.071.464m8.651-.19-.354.043.345-.005.009-.037M8.5,6.923a.574.574,0,0,1,.106.056l.221-.318a2.294,2.294,0,0,1-.317.226ZM7.127,8.441l-.177.074c.019,0,.031.016.051.019l.167.041s-.02-.052-.041-.134m4.536,4.184s-.107-.273.316-.631l1.134-.372L9.458,8.952l-.622-.017-.044.023,2.819,3.764a.538.538,0,0,1,.054-.1m2.025-2.087s.138-.317.29-.658l-2.95-.887L9.613,8.956l3.593,2.623a8.166,8.166,0,0,1,.483-1.041m.654-1.457L11.362,9l2.653.8c.134-.3.27-.6.328-.717m-5.4-.337c.021,0,.114.007.249.012l-.182-.132a.648.648,0,0,1-.067.12m.146-.334c-.016.052-.031.091-.044.13l.3.222,1.025.033Zm4.519-.554L9.3,8.382l1.411.424c1.605.048,3.719.107,3.719.107.082-.166.268-.808.344-1.078ZM12.043,13.7s-.666-.4-.482-.895L8.708,9l-.126.063,2.853,5.121a7.06,7.06,0,0,0,.678-.408ZM9.6,12.118l.908,2.5c.14-.054.281-.1.417-.165Zm.823,2.531-1.088-3L8.175,9.6l.231,5.459a7.06,7.06,0,0,0,2.02-.408M7.4,8.913l-3.332,4.97A7.043,7.043,0,0,0,6.5,14.921L7.784,9.191A1.107,1.107,0,0,1,7.4,8.913M7.02,8.68a1.42,1.42,0,0,1-.261-.086L1.522,10.8a7.01,7.01,0,0,0,.966,1.573L7.2,8.7Zm-.387-.13a1.142,1.142,0,0,1-.524-.515L.981,8.3a7.054,7.054,0,0,0,.511,2.424Zm.194-.082.28-.118a1.791,1.791,0,0,1-.037-.364l-.825.041a1.3,1.3,0,0,0,.583.44M5.953,7.3A1.453,1.453,0,0,1,6.2,6.654L2.243,3.969a7,7,0,0,0-.91,1.869Zm.135.043,1.025.325a.8.8,0,0,1,.162-.289l-.963-.653a1.178,1.178,0,0,0-.223.617m1.094-.132-.559-.785a1.33,1.33,0,0,0-.256.233Zm.171.087c.011-.009.016-.021.028-.031l-.066-.274-.251-.338a.568.568,0,0,1-.181-.015ZM7.064,6.067a.368.368,0,0,1,.285.037L5.625,1.4a7.009,7.009,0,0,0-1.794.959L6.616,6.265a1.615,1.615,0,0,1,.448-.2m.423.154a.807.807,0,0,1,.062.1c.253.169.273-.169.273-.169,0-.031.021-.054.037-.079l-.012-.895a.3.3,0,0,1,0-.165V4.96l-.23-.076c-.115-.134.032-.249.225-.336L7.787.975a7.021,7.021,0,0,0-2.076.4Zm.459-.241a1.278,1.278,0,0,1,.342-.126l.273.041L8.18,5.558a.946.946,0,0,1-.243-.209Zm.7-.633a.636.636,0,0,0,.106.32l.324-1.188-.3,0a.13.13,0,0,0-.146.126c.441.318.021.738.021.738M8.686,7.02a.944.944,0,0,1,.322.328l3.573-2.893c-.7,0-1.461.007-2.118.012Zm5.977-1.355L9.137,7.62c.035.1.056.175.056.175l5.782-.887.005-.031a7.013,7.013,0,0,0-.317-1.212m.8,12.572.021.277.127.041Zm-2.382-3.521-.27-.26a8.133,8.133,0,0,1-.894.583l.76,1.363a8,8,0,0,0,.4-1.687m-1.331,2.172a2.464,2.464,0,0,0,.128.4l.013.035.112.324.233-.4.126-.273-.738-1.181-.148.021a.556.556,0,0,1-.084.379Zm-.337-1.328.084-.106-.091-.161c-.06.028-.118.06-.178.087a.292.292,0,0,1,.185.179m-3.091-.494-.239-5.64-.087-.154a.769.769,0,0,1-.122-.048L6.582,14.946a7.013,7.013,0,0,0,1.442.15c.1,0,.194-.025.294-.029M4,13.827,7.34,8.838a1.082,1.082,0,0,1-.063-.091l-4.731,3.7A7.109,7.109,0,0,0,4,13.827M.971,8.2l5.091-.256a1.483,1.483,0,0,1-.118-.556L1.307,5.922a7.012,7.012,0,0,0-.353,2.1c0,.062.016.119.017.181M2.3,3.9,6.258,6.586a1.511,1.511,0,0,1,.284-.274l-2.777-3.9A7.084,7.084,0,0,0,2.3,3.9M7.875.967l.051,3.542a3.314,3.314,0,0,1,.444-.132l.737-.009.849-3.114a6.992,6.992,0,0,0-1.933-.3c-.051,0-.1.013-.148.015m4.162,1.24L10.545,4.349l2.2-.029.807-.653a7.077,7.077,0,0,0-1.518-1.459M25.652,17.879l-3.914-4.8a.443.443,0,0,0,.111.249s.451.451.352.8l.852,1.132.352.451a.447.447,0,0,1,.036.475,1.606,1.606,0,0,1-.17.266l.1.134s.011.219-.365.329l-.1-.122s-.292.233-.437.072a.278.278,0,0,1-.3-.11L20.254,14.3s-.389-.11-.389-.439l-.828-1.121a.318.318,0,0,1,.072-.448l1.085-.754a.36.36,0,0,1,.277-.012L18.582,9.209s-1.221.1-1.39.1-.023.063-.023.063l-.421,1.371a.411.411,0,0,1,.444.107l.546.19s.528.3.234.674a1.719,1.719,0,0,1-.761.381l-.547.21-.548.506-.233,2.154a1.947,1.947,0,0,1,.253.674s2,1.942,2.552,2.364c0,0,.591.653.781.843l5.317.423a.67.67,0,0,0,.823-.3s.59-.59.043-1.1m.337,4.855-.717-.253c-.317-.21.231-.3.231-.3l.063-.233c-.464-.231.084-.379.084-.379l.253-.781a.279.279,0,0,1-.1-.337,1.336,1.336,0,0,0-.487-.231L20.4,19.779a6.638,6.638,0,0,1,1.035,1.6c.527,1.1-.633,2.045-.633,2.045a16.208,16.208,0,0,1-2.152.993v.084L15.9,25.56l.634.486a2.91,2.91,0,0,1,.884.76,10.363,10.363,0,0,0,.888.93l.843.421a4.262,4.262,0,0,1,.95.506,2.033,2.033,0,0,0,.59.527A3.168,3.168,0,0,1,21.6,30.56,14.508,14.508,0,0,0,23.33,29a19.214,19.214,0,0,0,1.328-1.814,10.217,10.217,0,0,1,1.331-1.414,8.62,8.62,0,0,0,1.665-1.413l.823-.78.086-.317-.4.063a1.694,1.694,0,0,1-.591-.317l-1.455-.317Zm1.1-2.51s.189.041-.106.59c0,0-.191.189-.359.127l-.318.948,1.69.4a.571.571,0,0,1,.673,0l.122.02A4.34,4.34,0,0,0,27.325,20.1l-.177-.029Zm1.328-3.418.147.062a.242.242,0,0,1,.071-.115c-.06-.021-.122-.041-.181-.066-.023.071-.037.119-.037.119M27.7,15.117a13.507,13.507,0,0,1,.821-1.609L27.454,15.1c.064.044.139.071.206.112Zm-.313-.076L29.2,12.334c.536-.906,1.082-1.8,1.418-2.342l-4.691,3.665a7.12,7.12,0,0,0,1.458,1.385M24.344,9.4l6.537-.329-6.2-1.964a7.022,7.022,0,0,0-.359,2.118c0,.059.016.115.019.175m1.343-4.317,4.9,3.322L27.158,3.6a7.115,7.115,0,0,0-1.471,1.488m5.592-2.92L31.371,8.7a.812.812,0,0,1,.1-.036.439.439,0,0,1,.193,0l1.691-6.2a6.972,6.972,0,0,0-1.958-.31c-.041,0-.079.012-.119.012m.535,6.293,3.544-5.091a7.073,7.073,0,0,0-1.917-.878Zm3.612-5.035L31.753,8.7a.484.484,0,0,1,.2.219L36.935,4.88a7.083,7.083,0,0,0-1.51-1.455"
                        transform="translate(0 0)"
                        fill="#00a800"
                      />
                    </g>
                  </g>
                </svg>
              ) : (
                <svg width="41.476" height="42.31" viewBox="0 0 41.476 42.31">
                  <defs>
                    <clipPath id="clip-path">
                      <rect
                        id="Rectangle_764"
                        data-name="Rectangle 764"
                        width="39.421"
                        height="40.303"
                        fill="#00a8ff"
                      />
                    </clipPath>
                  </defs>
                  <g
                    id="Group_1840"
                    data-name="Group 1840"
                    transform="translate(41.476 40.247) rotate(177)"
                  >
                    <g
                      id="Group_1684"
                      data-name="Group 1684"
                      transform="translate(0 0)"
                      clipPath="url(#clipPath)"
                    >
                      <path
                        id="Path_2057"
                        data-name="Path 2057"
                        d="M31.4,17.252a8.057,8.057,0,0,1-1.93-.243l-.08.26a.288.288,0,0,1-.464.127l-.211.613a.133.133,0,0,1,.02.19,1.6,1.6,0,0,1-.211.464v.031c.011.086.028.2.048.344l.292.067A3.073,3.073,0,0,1,31.181,20.9l.376-.441c.255-.13-.062.294-.062.294a.582.582,0,0,0-.041.633l.126-.211c.253-.062.314.423.314.423.254,0,.447.57.447.57l-.087-.444c-.062-.4.064-.506.064-.506l.38-.507a1.706,1.706,0,0,1,.316-.231c.19.064-.127.317-.127.317a1.218,1.218,0,0,0-.124.78c.189-.126.233-.041.233-.041.21.169,0,.654,0,.654a1.615,1.615,0,0,0-.087.441l-.21.53a.725.725,0,0,1,.21.569.407.407,0,0,1-.25.443.582.582,0,0,1-.678-.041,2,2,0,0,1-.589.253,4.872,4.872,0,0,0-.783.294.865.865,0,0,1-.4.211c-.4.444-2.324,2.828-2.324,2.828a13.405,13.405,0,0,1-2.067,1.857,13.8,13.8,0,0,0-1.16,1.1l-.63.8c.083.084-.193.484-.193.484l-.148.593a5.14,5.14,0,0,1-.294.864l.1.041a1.222,1.222,0,0,1,.654-.3.378.378,0,0,1,.571.36.577.577,0,0,0,.126.337.264.264,0,0,1,.044.3l.189-.023c.191-.04.233.276.233.276l.23.254.32-.086c.272-.02.126.7.126.7a1.9,1.9,0,0,1,.4.569c.126.338-.19.359-.19.359v.466l.844.274.527-.213c.359-.04.063.3.063.3-.063.063-.484.7-.484.7a7.872,7.872,0,0,1-1.265,1.71,3.828,3.828,0,0,1-2.891.844l-2.237-.338c-.338.021-.211-.253-.211-.253l.148-.317-.211.107c-.148.063-.17-.127-.17-.127l-.02-.3.423-.337a.564.564,0,0,1-.274-.317,1.35,1.35,0,0,1,.4-1.118c-.211-.19-.126-.59-.126-.59-.381.337-.506-.147-.506-.147.062-.34-.17-.36-.17-.36a1.146,1.146,0,0,1-.865-.147l-.95-.421-1.941-.865a19.193,19.193,0,0,1-2.932-1.71A9.178,9.178,0,0,1,11.684,31.6L9.743,29.149c-.887-.634-.55-1.12-.55-1.12l-.5-1.138a2.355,2.355,0,0,1-.15-2.618l.317-.547c-.357-.106.086-.548.086-.548l-.359-1.118A1.462,1.462,0,0,1,8.9,20.666v-.4c.169,0,.147.36.147.36l1.477-.107.466-.231.147-.443a12.474,12.474,0,0,1,.78-2.069l-.1-.421-.273-.211-.36-.843c-.55.106-.718-.527-.718-.527l-.012-.1a8.026,8.026,0,1,1,4.376-11.9l0-.051c.064-.844,1.224-.738,1.224-.738a3.88,3.88,0,0,1,.824.124c.167.15.676.128.676.128a6.692,6.692,0,0,0,1.2-.064c-.486-.231.084-.463.084-.463l1.034.146a.281.281,0,0,1,.253.21l-.148.171c.4.1,1.14.4,1.14.4.59.337.527.654.527.654-.041.464-.676.464-.676.464l-1.181.127c.02.19-.359.253-.359.253a2.587,2.587,0,0,1,.19,3.208l6.88,8.418c.379.421.484.064.484.064l.3-.72A8.012,8.012,0,1,1,31.4,17.252m-1.5-1.121,1.332-5.925a33.158,33.158,0,0,0-2.471,5.57,6.942,6.942,0,0,0,1.138.354m1.8-6.438,2.223,6.123a6.97,6.97,0,0,0,1.7-.943L31.728,9.68a.255.255,0,0,1-.037.013m-.083.028a.512.512,0,0,1-.075.013l.278,6.523a7.012,7.012,0,0,0,2.019-.415Zm-.661-.26h0L24.9,12.01a7.052,7.052,0,0,0,.973,1.579l4.884-3.816.193-.31m-.008-.094a.667.667,0,0,1,.008-.209l-6.595.332a7.04,7.04,0,0,0,.512,2.435ZM31.007,9l-.274-.385-5.1-3.461a7.021,7.021,0,0,0-.922,1.87L31,9.019,31.007,9m.051-.08a.608.608,0,0,1,.051-.051l-.166-.112Zm.119-.111a.855.855,0,0,1,.1-.068L29.028,2.592a7.022,7.022,0,0,0-1.8.95L30.8,8.552Zm.1-.329-.092-6.3a6.966,6.966,0,0,0-2.075.391Zm.708.531c0,.015.011.028.015.043L38.44,8.94a7.007,7.007,0,0,0-.4-2.067Zm6.024-2.223a7,7,0,0,0-1.018-1.841L32.166,8.856ZM32.023,9.143a1.2,1.2,0,0,1,.019.13c-.005.04-.028.06-.039.095l6.148,1.847a6.974,6.974,0,0,0,.318-1.987c0-.07-.019-.132-.02-.2Zm.092.353,5.109,3.73a7.024,7.024,0,0,0,.9-1.925Zm5.053,3.8L31.952,9.487a.488.488,0,0,1-.15.147l3.881,5.182a7.09,7.09,0,0,0,1.485-1.522m-5.447,2.972L31.448,9.85c-.025.04-.051.083-.078.124l-1.389,6.182A7.044,7.044,0,0,0,31.4,16.3c.111,0,.214-.027.324-.032m-3.18,1.72.147-.57-.443-.276-.528,1.33.754.531c-.009-.067-.016-.126-.025-.178l-.054-.2c-.062-.191.148-.633.148-.633m-.887.758-.19.528.761.274.02-.234Zm-.166,1.387a4.669,4.669,0,0,1,1.288,1.833c-.021-.429-.063-.912-.112-1.377a3.085,3.085,0,0,0-1.176-.456m2.162.436a2.775,2.775,0,0,1,.495,1.025c.3-.357.318.444.318.444l.189.041a.9.9,0,0,0,.063-.528,2.626,2.626,0,0,0-1.169-1.4,2.927,2.927,0,0,1,.1.415m-.221-.479a2.333,2.333,0,0,0-.53-.2,2.7,2.7,0,0,1,.627.531,2.99,2.99,0,0,0-.1-.326m0,2.326a1.566,1.566,0,0,0,.033-.318,2.858,2.858,0,0,1-.167.3Zm-.23-.039a2.587,2.587,0,0,0,.255-.482,1.756,1.756,0,0,0-.385-.943c.011.138.021.3.021.467a3.528,3.528,0,0,1-.111.922Zm-.314-.051h.005A3.475,3.475,0,0,0,29,21.419a4.934,4.934,0,0,0-.036-.578,1.6,1.6,0,0,0-.2-.182c.059.574.108,1.168.119,1.656l0,.011M15.608,21.108l.907-.043a.327.327,0,0,1,.421,0s.738.15.845.064a11.714,11.714,0,0,1-1.837-1.815l-.464-.062-.17,1.793a.3.3,0,0,0,.3.063M12.723,4.455,9.055,7.424c.02.043.032.076.048.115l5.533-1.957A7.031,7.031,0,0,0,14.1,4.46c-.375-.005-.855-.007-1.376-.005M14.015,4.3c-.124-.2-.261-.384-.4-.569l-.72.583ZM9.17,4.479,8.82,5.762c.032.04.058.07.058.07a.935.935,0,0,1,.274.3c0,.043-.027.084-.04.127l1.245-1.789c-.487,0-.9.008-1.187.012m1.268-.128,1.53-2.2a7.041,7.041,0,0,0-1.926-.874L9.2,4.366ZM6.156,7.9l.025.041L7.072,7.9A1.076,1.076,0,0,1,7.1,7.756l-1.01-.32a1.448,1.448,0,0,0,.071.464m8.651-.19-.354.043.345-.005.009-.037M8.5,6.923a.574.574,0,0,1,.106.056l.221-.318a2.294,2.294,0,0,1-.317.226ZM7.127,8.441l-.177.074c.019,0,.031.016.051.019l.167.041s-.02-.052-.041-.134m4.536,4.184s-.107-.273.316-.631l1.134-.372L9.458,8.952l-.622-.017-.044.023,2.819,3.764a.538.538,0,0,1,.054-.1m2.025-2.087s.138-.317.29-.658l-2.95-.887L9.613,8.956l3.593,2.623a8.166,8.166,0,0,1,.483-1.041m.654-1.457L11.362,9l2.653.8c.134-.3.27-.6.328-.717m-5.4-.337c.021,0,.114.007.249.012l-.182-.132a.648.648,0,0,1-.067.12m.146-.334c-.016.052-.031.091-.044.13l.3.222,1.025.033Zm4.519-.554L9.3,8.382l1.411.424c1.605.048,3.719.107,3.719.107.082-.166.268-.808.344-1.078ZM12.043,13.7s-.666-.4-.482-.895L8.708,9l-.126.063,2.853,5.121a7.06,7.06,0,0,0,.678-.408ZM9.6,12.118l.908,2.5c.14-.054.281-.1.417-.165Zm.823,2.531-1.088-3L8.175,9.6l.231,5.459a7.06,7.06,0,0,0,2.02-.408M7.4,8.913l-3.332,4.97A7.043,7.043,0,0,0,6.5,14.921L7.784,9.191A1.107,1.107,0,0,1,7.4,8.913M7.02,8.68a1.42,1.42,0,0,1-.261-.086L1.522,10.8a7.01,7.01,0,0,0,.966,1.573L7.2,8.7Zm-.387-.13a1.142,1.142,0,0,1-.524-.515L.981,8.3a7.054,7.054,0,0,0,.511,2.424Zm.194-.082.28-.118a1.791,1.791,0,0,1-.037-.364l-.825.041a1.3,1.3,0,0,0,.583.44M5.953,7.3A1.453,1.453,0,0,1,6.2,6.654L2.243,3.969a7,7,0,0,0-.91,1.869Zm.135.043,1.025.325a.8.8,0,0,1,.162-.289l-.963-.653a1.178,1.178,0,0,0-.223.617m1.094-.132-.559-.785a1.33,1.33,0,0,0-.256.233Zm.171.087c.011-.009.016-.021.028-.031l-.066-.274-.251-.338a.568.568,0,0,1-.181-.015ZM7.064,6.067a.368.368,0,0,1,.285.037L5.625,1.4a7.009,7.009,0,0,0-1.794.959L6.616,6.265a1.615,1.615,0,0,1,.448-.2m.423.154a.807.807,0,0,1,.062.1c.253.169.273-.169.273-.169,0-.031.021-.054.037-.079l-.012-.895a.3.3,0,0,1,0-.165V4.96l-.23-.076c-.115-.134.032-.249.225-.336L7.787.975a7.021,7.021,0,0,0-2.076.4Zm.459-.241a1.278,1.278,0,0,1,.342-.126l.273.041L8.18,5.558a.946.946,0,0,1-.243-.209Zm.7-.633a.636.636,0,0,0,.106.32l.324-1.188-.3,0a.13.13,0,0,0-.146.126c.441.318.021.738.021.738M8.686,7.02a.944.944,0,0,1,.322.328l3.573-2.893c-.7,0-1.461.007-2.118.012Zm5.977-1.355L9.137,7.62c.035.1.056.175.056.175l5.782-.887.005-.031a7.013,7.013,0,0,0-.317-1.212m.8,12.572.021.277.127.041Zm-2.382-3.521-.27-.26a8.133,8.133,0,0,1-.894.583l.76,1.363a8,8,0,0,0,.4-1.687m-1.331,2.172a2.464,2.464,0,0,0,.128.4l.013.035.112.324.233-.4.126-.273-.738-1.181-.148.021a.556.556,0,0,1-.084.379Zm-.337-1.328.084-.106-.091-.161c-.06.028-.118.06-.178.087a.292.292,0,0,1,.185.179m-3.091-.494-.239-5.64-.087-.154a.769.769,0,0,1-.122-.048L6.582,14.946a7.013,7.013,0,0,0,1.442.15c.1,0,.194-.025.294-.029M4,13.827,7.34,8.838a1.082,1.082,0,0,1-.063-.091l-4.731,3.7A7.109,7.109,0,0,0,4,13.827M.971,8.2l5.091-.256a1.483,1.483,0,0,1-.118-.556L1.307,5.922a7.012,7.012,0,0,0-.353,2.1c0,.062.016.119.017.181M2.3,3.9,6.258,6.586a1.511,1.511,0,0,1,.284-.274l-2.777-3.9A7.084,7.084,0,0,0,2.3,3.9M7.875.967l.051,3.542a3.314,3.314,0,0,1,.444-.132l.737-.009.849-3.114a6.992,6.992,0,0,0-1.933-.3c-.051,0-.1.013-.148.015m4.162,1.24L10.545,4.349l2.2-.029.807-.653a7.077,7.077,0,0,0-1.518-1.459M25.652,17.879l-3.914-4.8a.443.443,0,0,0,.111.249s.451.451.352.8l.852,1.132.352.451a.447.447,0,0,1,.036.475,1.606,1.606,0,0,1-.17.266l.1.134s.011.219-.365.329l-.1-.122s-.292.233-.437.072a.278.278,0,0,1-.3-.11L20.254,14.3s-.389-.11-.389-.439l-.828-1.121a.318.318,0,0,1,.072-.448l1.085-.754a.36.36,0,0,1,.277-.012L18.582,9.209s-1.221.1-1.39.1-.023.063-.023.063l-.421,1.371a.411.411,0,0,1,.444.107l.546.19s.528.3.234.674a1.719,1.719,0,0,1-.761.381l-.547.21-.548.506-.233,2.154a1.947,1.947,0,0,1,.253.674s2,1.942,2.552,2.364c0,0,.591.653.781.843l5.317.423a.67.67,0,0,0,.823-.3s.59-.59.043-1.1m.337,4.855-.717-.253c-.317-.21.231-.3.231-.3l.063-.233c-.464-.231.084-.379.084-.379l.253-.781a.279.279,0,0,1-.1-.337,1.336,1.336,0,0,0-.487-.231L20.4,19.779a6.638,6.638,0,0,1,1.035,1.6c.527,1.1-.633,2.045-.633,2.045a16.208,16.208,0,0,1-2.152.993v.084L15.9,25.56l.634.486a2.91,2.91,0,0,1,.884.76,10.363,10.363,0,0,0,.888.93l.843.421a4.262,4.262,0,0,1,.95.506,2.033,2.033,0,0,0,.59.527A3.168,3.168,0,0,1,21.6,30.56,14.508,14.508,0,0,0,23.33,29a19.214,19.214,0,0,0,1.328-1.814,10.217,10.217,0,0,1,1.331-1.414,8.62,8.62,0,0,0,1.665-1.413l.823-.78.086-.317-.4.063a1.694,1.694,0,0,1-.591-.317l-1.455-.317Zm1.1-2.51s.189.041-.106.59c0,0-.191.189-.359.127l-.318.948,1.69.4a.571.571,0,0,1,.673,0l.122.02A4.34,4.34,0,0,0,27.325,20.1l-.177-.029Zm1.328-3.418.147.062a.242.242,0,0,1,.071-.115c-.06-.021-.122-.041-.181-.066-.023.071-.037.119-.037.119M27.7,15.117a13.507,13.507,0,0,1,.821-1.609L27.454,15.1c.064.044.139.071.206.112Zm-.313-.076L29.2,12.334c.536-.906,1.082-1.8,1.418-2.342l-4.691,3.665a7.12,7.12,0,0,0,1.458,1.385M24.344,9.4l6.537-.329-6.2-1.964a7.022,7.022,0,0,0-.359,2.118c0,.059.016.115.019.175m1.343-4.317,4.9,3.322L27.158,3.6a7.115,7.115,0,0,0-1.471,1.488m5.592-2.92L31.371,8.7a.812.812,0,0,1,.1-.036.439.439,0,0,1,.193,0l1.691-6.2a6.972,6.972,0,0,0-1.958-.31c-.041,0-.079.012-.119.012m.535,6.293,3.544-5.091a7.073,7.073,0,0,0-1.917-.878Zm3.612-5.035L31.753,8.7a.484.484,0,0,1,.2.219L36.935,4.88a7.083,7.083,0,0,0-1.51-1.455"
                        transform="translate(0 0)"
                        fill="#00a8ff"
                      />
                    </g>
                  </g>
                </svg>
              )}
            </div>
            <div className="col-6 col-sm-4 col-lg-5">
              <h3 className="lufga-medium font-21 break">
                {thisBike.make} {thisBike.model}
              </h3>
            </div>
            <div className="col-4 col-sm-1">
              <h3 className="lufga-medium font-21">
                {currency(thisBike.value, {
                  symbol: "£",
                  separator: ",",
                  precision: 0,
                }).format()}
              </h3>{" "}
            </div>
            <div className="offset-4 col-4 offset-sm-1 col-sm-2">
              {" "}
              <button
                className="remove-button btn btn-wider"
                disabled={
                  gState.currentlyEditingABike || gState.currentlyAddingABike
                }
                onClick={(e) => {
                  handleRemove(bike.id);
                }}
              >
                REMOVE
              </button>
            </div>
            <div className="col-4 col-lg-2  offset-sm-1 offset-lg-0 col-sm-1 ">
              <button
                className="edit-button btn btn-wider"
                disabled={
                  gState.currentlyEditingABike || gState.currentlyAddingABike
                }
                onClick={(e) => {
                  handleEdit(bike.id);
                }}
              >
                EDIT
              </button>
            </div>
          </div>
          {gState.bikes.length === 1 && (
            <div className="row">
              <div className="col-2 col-sm-1"> </div>
              <div className="col-12 col-sm-8 lighterGreyFont">
                Your cycle will be covered away from home up to £{bike.value}
              </div>{" "}
            </div>
          )}
        </div>
      )}

      {editMode === true && (

        <div className="content_section mt-3">
          <h3 className="lufga-medium">
            Edit<span className="blueFont"> your bike</span>.
          </h3>
          <div className="row">
            <form onSubmit={formik.handleSubmit} noValidate>
              <div className="col-12 col-md-6">
                <div className="mb-3">
                  <label className="form-label">Make*</label>
                  <input
                    type="text"
                    maxLength={20}
                    className={`form-control ${formik.errors.bikeMake
                      ? formik.touched.bikeMake && "is-invalid"
                      : formik.touched.bikeMake && "is-valid"
                      }`}
                    id="bikeMake"
                    required
                    placeholder="Make/manufacturer of your bike"
                    value={formik.values.bikeMake}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.bikeMake && formik.errors.bikeMake ? (
                    <small className="redFont mt-1">
                      {formik.errors.bikeMake}
                    </small>
                  ) : null}
                </div>
                <div className="mb-3">
                  <label className="form-label">Model*</label>
                  <input
                    type="text"
                    maxLength={40}
                    className={`form-control ${formik.errors.bikeModel
                      ? formik.touched.bikeModel === true && "is-invalid"
                      : formik.touched.bikeModel === true && "is-valid"
                      }`}
                    id="bikeModel"
                    placeholder="Model of your bike"
                    value={formik.values.bikeModel}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.bikeModel && formik.errors.bikeModel ? (
                    <small className="redFont mt-1">
                      {formik.errors.bikeModel}
                    </small>
                  ) : null}
                </div>
                <div className="mb-3">
                  <label className="form-label">Value*</label>
                  <input
                    type="number"
                    className={`form-control ${formik.errors.bikeValue
                      ? formik.touched.bikeValue === true && "is-invalid"
                      : formik.touched.bikeValue === true && "is-valid"
                      }`}
                    id="bikeValue"
                    min={0}
                    max={10000}
                    onKeyUp={(e) => enforceMinMax(e)}
                    onKeyDown={(e) => enforceMinMax(e)}
                    placeholder="Value of your bike"
                    value={formik.values.bikeValue}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.bikeValue && formik.errors.bikeValue ? (
                    <small className="redFont mt-1">
                      {formik.errors.bikeValue}
                    </small>
                  ) : null}
                </div>
                <div className="mb-3 mt-3">
                  <label className="form-label">Is this bike electric?*</label>
                  <div className="row">
                    <div className="col-6 col-md-4">
                      <button
                        className={`btn btn-secondary btn-100 mb-2 mr-1 lufga ${formik.values.isElectric === true
                          ? "primaryFocussed"
                          : ""
                          }`}
                        value="true"
                        onClick={(e) => handleIsElectric(e, true)}
                      >
                        Yes
                      </button>
                    </div>
                    <div className="col-6 col-md-4">
                      <button
                        className={`btn btn-secondary btn-100 mb-2 mr-1 ${formik.values.isElectric === false
                          ? "primaryFocussed"
                          : ""
                          }`}
                        value="false"
                        onClick={(e) => handleIsElectric(e, false)}
                      >
                        No
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-10">
                <p className="bulletPoint">
                  Full information on our policy features can be found{" "}
                  <Link
                    to="/types-we-cover"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    here
                  </Link>
                  .
                </p>
              </div>

              <div className="col-12 col-md-6 mb-5 mt-3">
                <div className="form-group">
                  <div className="row">
                    <div className="col-6 col-md-4">
                      <button
                        id="edit-this-bike"
                        type="submit"
                        className="btn btn-primary  mb-2 btn-100"
                      >
                        Save changes
                      </button>
                    </div>
                    <div className="col-6 col-md-4">
                      <button
                        onClick={handleCancel}
                        className="btn btn-secondary  mb-2 btn-100"
                      >
                        Cancel update
                      </button>
                    </div>
                    {showEditBikeMessage && (
                      <small className="redFont mt-1">
                        Please finish editing this bike before continuing
                      </small>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </section>
  );
};

export default IndividualBike;
